import { Component, QueryList, ViewChildren, OnInit, ViewChild, inject, AfterViewInit  } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { BsModalService, BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormArray, UntypedFormControl, Validators, FormBuilder } from '@angular/forms';


import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import { selfcreditService } from '../self-credit.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { id } from 'date-fns/locale';
import { C } from '@fullcalendar/core/internal-common';

@Component({
  selector: 'app-co-debtor',
  templateUrl: './co-debtor.component.html',
  styleUrls: ['./co-debtor.component.scss'],
  providers: [DecimalPipe]
})

/**
 * Contacts user-list component
 */
export class CoDebtorComponent implements OnInit, AfterViewInit  {
  // bread crumb items
  private _formBuilder = inject(FormBuilder);

  isLinear = false;
  breadCrumbItems: Array<{}>;
  haveUser = false;

  Clientlist!: Observable<any[]>;
  total: Observable<number>;
  firstFormGroup!: UntypedFormGroup;
  secondFormGroup!: UntypedFormGroup;
  ThirdFormGroup!: UntypedFormGroup;
  editContactForm!: UntypedFormGroup;
  FifthFormGroup!: UntypedFormGroup;
  id;
  submitted = false;
  contacts: any;
  files: File[] = [];
  loading = false
  listData:any
  habilitado:any;
  textittle:any;
  valorTotalCredito;
  itemSearch:any;
  listado:any;

  clientes:boolean = false;
  clientesArray:any[]=[];

  displayedColumnsClients: string[] = [
    'id',
    'nombres',
    'apellidos',
    'correo',
    'identificacion',
    'estado',
    'accion'
  ];
  dataSourceClients!: MatTableDataSource<any>;
  @ViewChild('paginatorClients', { static: true }) paginatorClients!: MatPaginator;
  @ViewChild('sortClients') sortClients!: MatSort;


  nombreP:string
  apellidosP:string
  identificacionP:string
  idclienteP:string
  correo:string
  listaDeCreditosFiltrada:[] = [];

@ViewChild('newContactModal', { static: false }) newContactModal: ModalDirective;
  @ViewChild('loadingModal', { static: false }) loadingModal?: ModalDirective;
  @ViewChild('loadingCreateModal', { static: false }) loadingCreateModal?: ModalDirective;


  constructor(
    private modalService: BsModalService, 
    public service: selfcreditService,
    private router: Router, 
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute) {
    this.loading = true
  }

  createReference(): UntypedFormGroup {
    return this.formBuilder.group({
      name: ['', Validators.required],
      cellPhone: ['', [Validators.required]],
      bond: ['', Validators.required]
    });
  }
  ngAfterViewInit() {
    if (this.newContactModal) {
      this.newContactModal.show();
    }
  }

  ngOnInit() {
    this.firstFormGroup = this.formBuilder.group({
      name: ['', [Validators.required]],
      lastName : ['',[Validators.required]],
      documentType: ['', [Validators.required]],
      documentNumber: ['', [Validators.required]],
      city: ['', [Validators.required]],
      address: ['', [Validators.required]],
      phone: ['',],
      birthDate: ['',],
      cellPhone: ['', [Validators.required]],
      documents:[],
      email: ['', [Validators.required]],
      gender: ['', [Validators.required]],
      stratum: ['', [Validators.required]],
      cityBorn: ['', [Validators.required]],
      maritalStatus: ['', [Validators.required]],
      houseType: ['', [Validators.required]],
      housingTime: ['', [Validators.required]],
      academicLevel: ['', [Validators.required]]
    })

    this.secondFormGroup = this.formBuilder.group({
      employeeType: ['', [Validators.required]],
      enterpriseName: ['',],
      contractType: ['',]
    });

    this.ThirdFormGroup = this.formBuilder.group({
      incoming: ['', [Validators.required]],
      anotherIncoming: ['', [Validators.required]],
      personalExpenses: ['', [Validators.required]],
      creditExpenses: ['', [Validators.required]],
      totalAssets: ['', [Validators.required]],
      totalLiabilities: ['', [Validators.required]],
      totalIncoming: [{ value: 0, disabled: true }]
    });

    this.FifthFormGroup = this.formBuilder.group({
      references: this.formBuilder.array([this.createReference(), this.createReference()])
    });

  }

  filtrarListaClientes() {    
    const lowerCaseNombreP = this.nombreP ? this.nombreP.toLowerCase() : null;
    const lowerCaseApellidosP = this.apellidosP ? this.apellidosP.toLowerCase() : null;
    const lowerCaseIdentificacionP = this.identificacionP ? this.identificacionP.toLowerCase() : null;
    const lowerCaseCorreo = this.correo ? this.correo.toLowerCase() : null;
    
    this.listaDeCreditosFiltrada = this.listado.filter(item =>
      (!lowerCaseNombreP || item.name?.toLowerCase().includes(lowerCaseNombreP)) &&
      (!lowerCaseApellidosP || item.lastName?.toLowerCase().includes(lowerCaseApellidosP)) &&
      (!lowerCaseIdentificacionP || item.documentNumber?.toLowerCase().includes(lowerCaseIdentificacionP)) &&
      (!lowerCaseCorreo || item.email?.toLowerCase().includes(lowerCaseCorreo)) &&
      (this.idclienteP ? item.id === Number(this.idclienteP) : true)
    );
    
    this.dataSourceClients = new MatTableDataSource(this.listaDeCreditosFiltrada);
    this.dataSourceClients.paginator = this.paginatorClients;
  }

  detalle(obj:any){
    this.router.navigate(['/detailclient'], {
      state: { data: obj }
    });
  }

  get references(): UntypedFormArray {
    return this.FifthFormGroup.get('references') as UntypedFormArray;
  }

  onDocumentNumberInput(event: Event,controlador): void {
    const input = event.target as HTMLInputElement;
    this.firstFormGroup.controls[controlador].setValue(input.value.replace(/[^0-9]/g, ''))
  }

  
  onDocumentNumberInputFrom3(event: Event,controlador): void {
    const input = event.target as HTMLInputElement;
    this.ThirdFormGroup.controls[controlador].setValue(this.formatNumberAsValue(input))
    this.calculateTotalIncome();
  }

  formatNumberAsValue($input: HTMLInputElement){
    return parseFloat($input.value.replace(/[^0-9]/g, '')).toLocaleString('en-US')
  }


  onFileSelected(event: any): void {
    const selectedFiles: FileList = event.target.files;
    const fileArray: File[] = Array.from(selectedFiles);
    this.convertAndSendFiles(fileArray);  
  }

  convertAndSendFiles(files: File[]) {
    const base64Array: any[] = [];  
    for (const file of files) {
      const reader = new FileReader();  
      reader.onload = (e: any) => {
        const base64String: string = e.target.result;
        let partes: string[] = base64String.split(',');
        base64Array.push({
          id: 0,
          name: file.name,
          url: 's', 
          content: partes[1],
        }); 
        
        if (base64Array.length === files.length) {
          this.uploadFiles(base64Array);
        }
      };  
      reader.readAsDataURL(file);
    }
  }
  
  uploadFiles(files): void {
    this.firstFormGroup.controls['documents'].setValue(files);
}

  // Save User
  saveUser() {
    const unifiedExtraData = {
      email: this.firstFormGroup.get('email').value,
      customerDocument: this.firstFormGroup.get('documentNumber').value,
    }

    if (this.firstFormGroup.valid && this.secondFormGroup.valid && this.ThirdFormGroup.valid) {
    this.loadingCreateModal.show(); 
    
    if(this.haveUser){
      const unifiedData = {
        ...this.firstFormGroup.value, 
        ...this.secondFormGroup.value,
        ...this.ThirdFormGroup.value,
        incoming: parseInt(this.ThirdFormGroup.get('incoming').value ? this.ThirdFormGroup.get('incoming').value.replace(/,/g, '') : 0),
        anotherIncoming: parseInt(this.ThirdFormGroup.get('anotherIncoming').value ? this.ThirdFormGroup.get('anotherIncoming').value.replace(/,/g, '') : 0),
        personalExpenses: parseInt(this.ThirdFormGroup.get('personalExpenses').value ? this.ThirdFormGroup.get('personalExpenses').value.replace(/,/g, '') : 0),
        creditExpenses: parseInt(this.ThirdFormGroup.get('creditExpenses').value ? this.ThirdFormGroup.get('creditExpenses').value.replace(/,/g, '') : 0),
        totalAssets: parseInt(this.ThirdFormGroup.get('totalAssets').value ? this.ThirdFormGroup.get('totalAssets').value.replace(/,/g, '') : 0),
        totalLiabilities: parseInt(this.ThirdFormGroup.get('totalLiabilities').value ? this.ThirdFormGroup.get('totalLiabilities').value.replace(/,/g, '') : 0),
        id: this.id
      };
        this.service.editUser(unifiedData).subscribe((resp:any) => {
          this.service.saveCreditInfo(unifiedExtraData).subscribe((resp2:any) =>{
            Swal.fire('',resp2.success ? resp2.data : resp.error,resp2.success ? 'success' : 'error').then(resp2 => {window.location.reload();})
            this.loadingCreateModal.hide(); 
          },error => {
            this.loadingCreateModal.hide(); 
            Swal.fire({
              icon: 'error',
              text: 'No pudimos realizar el registro, intenta nuevamente'
            })      
          })
          
        }, error => {
          this.loadingCreateModal.hide(); 
          Swal.fire({
            icon: 'error',
            text: 'No pudimos realizar el registro, intenta nuevamente'
          })      
        })
    }else{
      const unifiedData = {
        ...this.firstFormGroup.value, 
        ...this.secondFormGroup.value,
        ...this.ThirdFormGroup.value,
        incoming: parseInt(this.ThirdFormGroup.get('incoming').value ? this.ThirdFormGroup.get('incoming').value.replace(/,/g, '') : 0),
        anotherIncoming: parseInt(this.ThirdFormGroup.get('anotherIncoming').value ? this.ThirdFormGroup.get('anotherIncoming').value.replace(/,/g, '') : 0),
        personalExpenses: parseInt(this.ThirdFormGroup.get('personalExpenses').value ? this.ThirdFormGroup.get('personalExpenses').value.replace(/,/g, '') : 0),
        creditExpenses: parseInt(this.ThirdFormGroup.get('creditExpenses').value ? this.ThirdFormGroup.get('creditExpenses').value.replace(/,/g, '') : 0),
        totalAssets: parseInt(this.ThirdFormGroup.get('totalAssets').value ? this.ThirdFormGroup.get('totalAssets').value.replace(/,/g, '') : 0),
        totalLiabilities: parseInt(this.ThirdFormGroup.get('totalLiabilities').value ? this.ThirdFormGroup.get('totalLiabilities').value.replace(/,/g, '') : 0),
        customerId: this.route.snapshot.paramMap.get('id'),
      };
      this.service.SaveCodebtor(unifiedData).subscribe((resp:any) => {
        Swal.fire('',resp.success ? resp.data : resp.error,resp.success ? 'success' : 'error').then(resp2 => {window.location.reload();})
        this.loadingCreateModal.hide(); 
      }, error => {
        this.loadingCreateModal.hide(); 
        Swal.fire({
          icon: 'error',
          text: 'No pudimos realizar el registro, intenta nuevamente'
        })      
      })
    }
   }
  }

  calculateTotalIncome() {
    let $incoming = this.ThirdFormGroup.get('incoming').value ? this.ThirdFormGroup.get('incoming').value.replace(/,/g, '') : 0;
    let $anotherIncoming = this.ThirdFormGroup.get('anotherIncoming').value ? this.ThirdFormGroup.get('anotherIncoming').value.replace(/,/g, '') : 0

    let sum = parseInt($incoming) + parseInt($anotherIncoming);
    let value: string = sum.toLocaleString('en-US')
    this.ThirdFormGroup.get('totalIncoming').setValue(value);
  }
}
